import {
  useListingActions,
  useListingStatus,
} from '@brightmls/nextgen.lae.flc';
import { useMediaStoreReadonly } from '@brightmls/nextgen.lae.mediacenter';
import { useModal } from '../ModalContext';
import { useManageListingsNavigation } from '../../hooks/useManageListingsNavigation';
import BackHandlerContent from '../../components/common/BackHandlerContent';

export const useExit = (publish: () => void) => {
  const { saveListing, discardListing } = useListingActions();
  const { showModal, hideModal } = useModal();
  const { back } = useManageListingsNavigation();
  const { isMediaPending } = useMediaStoreReadonly();

  const isNavigatingAway = useListingStatus<boolean>('isNavigatingAway', false);

  const exit = async (hasErrors: boolean, isFromLiveListing: boolean) => {
    if (isFromLiveListing) {
      showModal({
        title: "You're not done yet...",
        width: 'lg',
        content: (
          <BackHandlerContent
            publish={publish}
            hasErrors={hasErrors}
            isMediaPending={isMediaPending}
            discardListing={discardListing}
            saveListing={saveListing}
            back={back}
            onClose={() => {
              hideModal();
            }}
          />
        ),
      });
    } else {
      isNavigatingAway.updateValue(true);

      await saveListing();

      back();

      isNavigatingAway.updateValue(false);
    }
  };

  return { exit };
};
